(() => {
  document.querySelectorAll('[data-hs-buy]').forEach(root => {
    const form = root.querySelector('form');
    const fallback = form.querySelector('.hs-native-choice');
    const gift = root.querySelector('.hs-native-gift');
    const status = form.querySelector('[role=status]');
    let lastActive;
    const sync = () => {
      const active = !!form.querySelector('kaching-bundles-block');
      if (active === lastActive) return;
      lastActive = active;
      fallback.hidden = active;
      fallback.querySelectorAll('input,select').forEach(element => {
        if (active) {
          if (!element.dataset.hsDisabled) element.dataset.hsDisabled = String(element.disabled);
          element.disabled = true;
        } else if (element.dataset.hsDisabled) {
          element.disabled = element.dataset.hsDisabled === 'true';
          delete element.dataset.hsDisabled;
        }
      });
      if (gift) gift.hidden = active;
      form.dataset.kachingActive = String(active);
    };
    new MutationObserver(sync).observe(form, {childList: true, subtree: true});
    sync();
    form.addEventListener('submit', async event => {
      if (form.dataset.kachingActive === 'true') return;
      event.preventDefault();
      const button = form.querySelector('[type=submit]');
      if (button.disabled) return;
      const body = new FormData(form);
      const map = root.querySelector('[data-ref-bundle-map]');
      const routesRoot = window.Shopify?.routes?.root || '/';
      let added = false;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = 'Adding to cart…';
      try {
        if (map) {
          const row = JSON.parse(map.textContent).find(row => row.sourceId === body.get('id') && row.quantity === Number(body.get('quantity')));
          if (!row || !row.available) throw new Error('Please choose an available size and bundle.');
          body.set('id', row.variantId);
          body.set('quantity', '1');
        }
        if (window.HSCart) {
          body.set('sections', window.HSCart.section);
          body.set('sections_url', location.pathname);
          window.HSCart.begin();
        }
        const response = await fetch(routesRoot + 'cart/add.js', {method: 'POST', body, headers: {Accept: 'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
        added = true;
        status.textContent = 'Added to your cart.';
        if (window.HSCart) await window.HSCart.added(result.sections);
        else {
          const link = document.createElement('a');
          link.href = routesRoot + 'cart';
          link.textContent = ' View cart';
          status.append(link);
        }
      } catch (error) {
        window.HSCart?.failed(added ? 'Your item was added, but the cart could not refresh. Please reopen your cart.' : error.message);
        status.textContent = added ? 'Added to your cart, but the drawer could not refresh. ' : error.message;
        if (added) {
          const link = document.createElement('a');
          link.href = routesRoot + 'cart';
          link.textContent = 'View cart';
          status.append(link);
        }
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  });
  const sticky = document.querySelector('[data-hs-sticky]');
  const buy = document.querySelector('[data-hs-buy]');
  if (sticky && buy) {
    let scheduled = false, lastVisible;
    const stickyLink = sticky.querySelector('a');
    const syncSticky = () => {
      const visible = buy.getBoundingClientRect().bottom < 0;
      if (visible === lastVisible) { scheduled = false; return; }
      lastVisible = visible;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
      stickyLink?.setAttribute('tabindex', visible ? '0' : '-1');
      scheduled = false;
    };
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(syncSticky); } };
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.addEventListener('pageshow', schedule);
    new IntersectionObserver(syncSticky).observe(buy);
    schedule();
  }
  document.querySelectorAll('video').forEach(video => {video.preload = 'none'; video.removeAttribute('autoplay');});
})();
